export default "__VITE_PUBLIC_ASSET__e6b5087c__"